import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Central Texas Tamil Academy</h4>
          <p>மத்திய டெக்சாஸ் தமிழ் கழகம்</p>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>
            <a href="mailto:admin@centextamilacademy.org">
              admin@centextamilacademy.org
            </a>
          </p>
          <p>Austin, TX 78717</p>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="footer-social">
            <a
              href="https://www.facebook.com/groups/centraltexastamilacademy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              title="Facebook"
            >
              <span className="facebook-icon-footer">f</span>
              Facebook
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#calendar">Calendar</a></li>
            <li><a href="#location">Location</a></li>
            <li><a href="#contactus">Contact Us</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} Central Texas Tamil Academy. All rights reserved.</p>
        <p>A non-profit 501c3 organization</p>
      </div>
    </footer>
  );
}

export default Footer;
